export default __webpack_public_path__ + "pgnv-assets/6d2aa73eee0ac61087962d65328efc66.png";